/** Schemes that must not be used for redirects (XSS). */
const FORBIDDEN_SCHEMES = ['javascript:', 'data:', 'vbscript:'];

/**
 * Returns a safe return URL for post-login redirects.
 * Allows:
 * - Same-origin absolute URLs
 * - Relative paths beginning with a single "/" (not protocol-relative)
 * Rejects javascript:, data:, vbscript: and cross-origin URLs.
 */
export const getSafeReturnUrl = (rawUrl) => {
	if (!rawUrl || typeof rawUrl !== 'string') {
		return null;
	}

	const trimmed = rawUrl.trim();
	if (!trimmed) {
		return null;
	}

	// Reject dangerous schemes before parsing (XSS)
	const lower = trimmed.toLowerCase();
	if (FORBIDDEN_SCHEMES.some((scheme) => lower.startsWith(scheme))) {
		return null;
	}

	// Allow relative app paths like "/home/project/ABC" (not protocol-relative "//")
	if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
		return trimmed;
	}

	// Allow only same-origin absolute URLs
	try {
		const parsed = new URL(trimmed, window.location.origin);
		if (parsed.origin !== window.location.origin) {
			return null;
		}
		return parsed.pathname + parsed.search + parsed.hash;
	} catch (error) {
		return null;
	}
};
